module.exports = __webpack_public_path__ + "static/media/confirmation.305874b9.m4a";